import { useHealth } from "@/hooks/useHealth";

/**
 * Banda di stato sistema per lo staff: raggiungibilità del backend
 * (servizio/versione/ambiente). L'alert su pricing modelli AI è predisposto qui
 * quando l'endpoint AI Ops esporrà i modelli senza prezzo configurato.
 */
export function WidgetDevBand() {
  const { data: health } = useHealth();
  return (
    <div className="flex flex-wrap items-center gap-x-3 gap-y-1 text-xs text-muted-foreground">
      <span>backend</span>
      {health ? (
        <code className="font-mono text-foreground">
          {health.servizio}@{health.versione} · {health.ambiente}
        </code>
      ) : (
        <span className="text-destructive">non raggiungibile</span>
      )}
    </div>
  );
}
